"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useDeepCompareEffect_1 = require("../hooks/useDeepCompareEffect");
function useQuery(_a) {
    var _this = this;
    var handleQuery = _a.handleQuery, queryOptions = tslib_1.__rest(_a, ["handleQuery"]);
    var _b = tslib_1.__read(react_1.useState(true), 2), isLoading = _b[0], setLoading = _b[1];
    var _c = tslib_1.__read(react_1.useState(undefined), 2), error = _c[0], setError = _c[1];
    var _d = tslib_1.__read(react_1.useState(undefined), 2), data = _d[0], setData = _d[1];
    var fetchQuery = function (queryOptions) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var data_1, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, handleQuery(queryOptions)];
                case 1:
                    data_1 = _a.sent();
                    setData(data_1);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    setError(error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var refetch = function () {
        fetchQuery(queryOptions);
    };
    useDeepCompareEffect_1.useDeepCompareEffect(function () {
        fetchQuery(queryOptions);
    }, [queryOptions]);
    return {
        isLoading: isLoading,
        data: data,
        error: error,
        refetch: refetch,
    };
}
exports.useQuery = useQuery;
//# sourceMappingURL=Query.js.map